export const ChangeClientStatusMessages = {
    DifferentStatusCheckFailed: {
        key: 'DifferentStatusCheckFailed',
        message: 'Different status must be selected.'
    },
    CantFindTradingClient: {
        key: 'CantFindTradingClient',
        message: 'To change client\'s status, cash and trading accounts should be created first.'
    },
    TradingGroupStatusUpdateFailed: {
        key: 'TradingGroupStatusUpdateFailed',
        message: 'Activation of cash account with reference <<reference>> failed. Activate account manually.'
    },
    TradingAccountStatusUpdateFailed: {
        key: 'TradingAccountStatusUpdateFailed',
        message: 'Activation of trading account with reference <<reference>> failed. Activate account manually.'
    },
    CantFindGroupsAndAccountsForActivation: {
        key: 'CantFindGroupsAndAccountsForActivation',
        message: 'Client doesn\'t have cash or trading accounts for activation. Create and activate them.'
    },
    ClientStatusChangeFailed: {
        key: 'ClientStatusChangeFailed',
        message: 'Unable to change client status.'
    },
    ClientStatusChangeSucceed: {
        key: 'ClientStatusChangeSucceed',
        message: 'The status is successfully changed.'
    },
    AddTradingAccountAdditionalPermissions: {
        key: 'AddTradingAccountAdditionalPermissions',
        message: 'Additional permissions are required for cash/trading account creation.'
    },
    ChangeStatusToTerminatedRestricted: {
        key: 'ChangeStatusToTerminatedRestricted',
        message: 'Additional permissions are required for client termination.'
    }
};
